import { string, object, mixed, array } from 'yup';
import { FIELD_TYPES } from '@src/shared/types/field';
import {
  COLUMN_TYPES,
  getCustomFieldColumnByType,
  type ColumnTypeOption,
} from './constants/column-types';
import type { TCustomField } from '@src/shared/types/custom-field';

export const TYPES_WITH_OPTIONS = [
  FIELD_TYPES.dropdown,
  FIELD_TYPES.checklist,
  FIELD_TYPES.ratio,
] as unknown as string[];

export const createCustomFieldsInitialValues = (customField?: TCustomField) => {
  return {
    name: '',
    type: COLUMN_TYPES[0],
    options: [],

    ...createCustomFieldsInitialValuesFromExisting(customField),
  };
};

const createCustomFieldsInitialValuesFromExisting = (
  customField?: TCustomField
) => {
  if (!customField) return {};

  const column = getCustomFieldColumnByType(customField.type);

  return {
    name: customField.label,
    type: column || COLUMN_TYPES[0],
    options: customField.options,
  };
};

export const customFieldsFormSchema = object().shape({
  name: string().required('Name is required'),
  type: mixed().required('Type is required'),
  options: array()
    .of(string())
    .when('type', {
      is: (type: ColumnTypeOption) => TYPES_WITH_OPTIONS.includes(type.value),
      then: (schema) =>
        schema
          .required('Options is required')
          .min(1, 'At least one option is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export type TCustomFieldsFormValues = ReturnType<
  typeof createCustomFieldsInitialValues
>;
